<template>
    <div class="friend-view">
        <div class="notice">
            <p>活动期间，邀请符合条件的老友接受你的专属链接，<b>并登录游戏</b>即算邀请成功，可解锁并领取相应数量的邀请奖励</p>
            <div class="u-btn old" @click="$old_modal();"></div>
        </div>

        <div class="list-view">
            <div class="label"></div>
            <div class="list-swiper">
                <ul>
                    <li v-for="(item,index) in list.slice(0 , 5)" :key="index" :class=" !item.isLoginGame? 'wait' : ''">
                        <div class="avatar"><img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/a/' + item.headImg +'.png'"></div>
                        <p class="player-name">{{ item.nickName }}</p>
                        <div class="status" :class="item.isLoginGame ? 'act' : ''"></div>
                    </li>                 
                </ul>

                <ul v-if="list.length < 5">
                    <li v-for="n in (5 - list.length)" :key="n" class="add" @click="call_share()">
                        <div class="avatar"></div>
                        <p class="player-name"></p>
                        <div class="status"></div>                        
                    </li>
                </ul>

                <div class="u-btn more" @click="get_friend_list"></div>
            </div>
        </div>

        <div class="invite-reward">
            <div class="reward-view">
                <div class="label"></div>
                <div class="reward-list" v-if="ready">
                    <ul>
                        <li v-for="(item,index) in reward_list" :key="'r-' + index">
                            <p class="tag">{{ index + 1 }}名老友</p>
                            <div class="item-status">
                                <div class="status-on" v-if="parse > index"></div>
                            </div>
                            <div class="item" 
                            @click="$item_tips(item.giftId + '_' + item.sendNum)" 
                            @mouseover="$tips_on($event,item.giftId + '_' + item.sendNum)"
                            @mouseleave="$tips_off()"
                            >
                                <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + item.giftId + '_' + item.sendNum + '.jpg'" v-if="item.sendNum > 1">
                                <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + item.giftId + '.jpg'" v-if="item.sendNum == 1">
                            </div>
                            <p class="item-name">{{ item.giftName }}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="u-btn apply" @click="apply_gift()" v-if="gift_apply > 0 "></div>
            <div class="u-btn apply dismiss" v-else></div>
        </div>
    </div>
</template>

<style scoped>

@media screen and (min-device-width: 1025px){
    .friend-view .notice{
        font-size: 14px;
        color: #5c483c;
        text-align: center;
    }

    .friend-view .notice b{
        color: #a2332f;
    }

    .friend-view .notice p{
        display: inline-block;
        vertical-align: middle;
    }

    .u-btn.old{
        display: inline-block;
        width: 118px;
        height: 31px;
        margin-left: 10px;
        background-image: url(../images/btn-old.png);
        vertical-align: middle;
    }

    .u-btn.old:hover{
        background-image: url(../images/btn-old_hover.png);
    }

    .invite-reward .u-btn.apply{
        width: 253px;
        height: 84px;
        margin: 35px auto 0;
        background-image: url(../images/btn-apply_invite.png);
    }

    .invite-reward .u-btn.apply:hover{
        background-image: url(../images/btn-apply_invite_hover.png);
    }

    .friend-view .list-view{
        position: relative;
        display: flex;
        margin-top: 50px;
        padding-left: 70px;
    }

    .friend-view .list-view .label{
        position: absolute;
        left: 0;
        top: 0;
        width: 37px;
        height: 117px;
        background-image: url(../images/label-invite.png);
    }

    .list-swiper{
        display: flex;
        align-items: center;
    }

    .friend-view .list-swiper ul{
        display: flex;
    }

    .friend-view .list-swiper li{
        position: relative;
        margin-right: 40px;
    }

    .friend-view .list-swiper .avatar{
        width: 133px;
        height: 137px;
        background-image: url(../images/bg-avatar.png);
    }

    .friend-view .player-name{
        width: 133px;
        height: 24px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;        
        color: #a79079;
        text-align: center;
    }

    .list-swiper .avatar img{
        width: 100%;
        height: 100%;
    }

    .friend-view .list-swiper .add .avatar{
        background-image: url(../images/bg-add.png);
    }

    .friend-view .list-swiper .status{
        width: 74px;
        height: 25px;
        margin: 5px auto 0;
        background-image: url(../images/status-wait.png);
    }

    .friend-view .list-swiper .status.act{
        background-image: url(../images/status-done.png);
    }

    .friend-view .list-swiper li.wait::after{
        display: block;
        content: '';
        position: absolute;
        top: -10px;
        right: -10px;
        width: 33px;
        height: 96px;
        background-image: url(../images/label-wait.png);
    }

    .friend-view .reward-view{
        position: relative;
        display: flex;
        margin-top: 85px;
        padding-left: 70px;
    }

    .friend-view .reward-view .label{
        position: absolute;
        left: 0;
        top: 0;        
        width: 37px;
        height: 117px;
        background-image: url(../images/label-reward.png);
    }
    
    .friend-view .reward-view .reward-list{
        width: 888px;
        padding-top: 70px;
        background-image: url(../images/bg-invite-reward.png);
        background-position: top left;
        background-repeat: no-repeat;
    }

    .friend-view .reward-view ul{
        display: flex;
        margin: -105px 64px 0 30px;
        justify-content: space-between;
    }

    .friend-view .reward-list .tag{
        font-size: 18px;
        font-weight: 700;
        color: #a79079;
        text-align: center;
    }

    .friend-view .reward-list .item-status{
        position: relative;
        width: 28px;
        height: 29px;
        margin: 0 auto 25px;
        background-image: url(../images/bg-f-wait.png);
    }

    .friend-view .item-status .status-on{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 50px;
        height: 34px;
        background-image: url(../images/bg-get.png);
        transform: translate(-52%,-60%);
    }

    .friend-view .reward-list .item{
        width: 83px;
        height: 80px;
        background-image: url(../images/bg-item.png);
    }

    .friend-view .reward-list .item-name{
        margin-top: 12px;
        font-size: 14px;
        color: #5c483c;
        text-align: center;
    }

    .u-btn.more{
        width: 83px;
        height: 78px;
        background-image: url(../images/btn-next.png);
    }
}


@media screen and (max-device-width: 1024px){
    .friend-view .notice{
        position: relative;
        padding-top: 95px;
        color: #5c483c;
    }

    .friend-view .notice b{
        color: #a2332f;
    }

    .friend-view .notice p{
        display: inline-block;
        vertical-align: middle;
    }
    
    .friend-view .notice .u-btn{
        position: absolute;
        left: 50%;
        top: 0;
        width: 218px;
        height: 65px;
        background-image: url(../images/m/btn-old.png);
        transform: translateX(-50%);
    }

    .friend-view .list-view .label{
        width: 330px;
        height: 93px;
        margin: 20px auto 10px;
        background-image: url(../images/m/label-1.png);
    }
    
    .list-swiper{
        display: flex;
        align-items: center;
    }

    .friend-view .list-swiper ul{
        display: flex;
    }

    .friend-view .list-swiper li{
        position: relative;
        margin-right: 20px;
    }

    .friend-view .list-swiper .avatar{
        width: 102px;
        height: 105px;
        background-image: url(../images/m/bg-avatar.png);
    }

    .friend-view .player-name{
        width: 102px;
        height: 30px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;        
        color: #a79079;
        text-align: center;
    }    

    .list-swiper .avatar img{
        width: 100%;
        height: 100%;
    }

    .friend-view .list-swiper .add .avatar{
        background-image: url(../images/m/bg-add.png);
    }

    .friend-view .list-swiper .status{
        width: 90px;
        height: 32px;
        margin: 14px auto 0;
        background-image: url(../images/m/status-now.png);
    }

    .friend-view .list-swiper .status.act{
        background-image: url(../images/m/status-done.png);
    }

    .friend-view .list-swiper li.wait::after{
        display: block;
        content: '';
        position: absolute;
        top: -10px;
        right: -10px;
        width: 41px;
        height: 122px;
        background-image: url(../images/m/label-wait.png);
    }
    
    .u-btn.more{
        width: 61px;
        height: 60px;
        background-image: url(../images/m/btn-friend-more.png);
    }
    
    .friend-view .reward-view .label{       
        width: 330px;
        height: 93px;
        margin: 15px auto 55px;
        background-image: url(../images/m/label-2.png);
    }
    
    .friend-view .reward-view .reward-list{
        width: 672px;
        padding-top: 75px;
        background-image: url(../images/m/bg-login-friend.png);
        background-position: top left;
        background-repeat: no-repeat;
    }

    .friend-view .reward-view ul{
        display: flex;
        margin-top: -122px;
        justify-content: space-between;
    }

    .friend-view .reward-list .tag{
        font-size: 24px;
        font-weight: 700;
        color: #a79079;
        text-align: center;
    }

    .friend-view .reward-list .item-status{
        position: relative;
        width: 42px;
        height: 42px;
        margin: 0 auto 25px;
        background-image: url(../images/m/icon-off.png);
    }

    .friend-view .item-status .status-on{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 72px;
        height: 50px;
        background-image: url(../images/m/icon-check.png);
        transform: translate(-52%,-60%);
    }

    .friend-view .reward-list .item{
        width: 92px;
        height: 89px;
        background-image: url(../images/m/bg-item.png);
    }

    .friend-view .reward-list .item-name{
        width: 92px;
        margin-top: 12px;
        font-size: 24px;
        color: #5c483c;
        text-align: center;
    }
    
    .invite-reward .u-btn.apply{
        width: 218px;
        height: 65px;
        margin: 40px auto 0;
        background-image: url(../images/m/btn-apply.png);
    }    
}

</style>

<script>
    export default {
        name: 'friend-view',
        data () {
            return {
                list : [],
                parse : 0,
                reward_list : [],
                ready : false,
                gift_apply : false,
            }
        },
        props : {
            ua : {
                default : {},
            },
            login : {
                default : 0,
            }
        },
        created () {
            var _this = this;
            if(_this.ua.areaId && _this.login)_this.update_list();
            _this.get_task_info();
        },
        methods : {
            update_list (){
                var _this = this;
                this.$axios.get(this.$global.ajax_url_map.friend_list)
                .then(res => {
                    if(res.data.code == 0){
                        _this.list = res.data.data.list;
                    }
                    else{
                        _this.$toast(res.data.message);
                    }
                });

                if(!this.login || !this.ua.areaId)return;

                this.$axios.get(this.$global.ajax_url_map.task_info,{
                    params: {
                        utype : 0,
                        gid : 1,
                    }
                })
                .then(res => {
                    if(res.data.code == 0){
                        var _login_task_info = res.data.data.splice(0,5);
                        this.gift_apply = _login_task_info.filter((e) => {
                            return e.isSubmit == false && e.isCompleted == true;
                        }).length;

                        var _login_cnt = _login_task_info.filter((e) => {
                            return e.isCompleted == true;
                        });
                        this.parse = _login_cnt.length;
                    }
                    else{
                        _this.$toast('任务模块:' + res.data.message);
                    }
                });                
            },
            call_share (){

                if(!this.login)return this.$mslogin.open();
                if(!this.ua.areaId)return this.$bind();

                this.$share_modal({
                    code : this.ua.inviteCode,
                })
            },
            apply_gift (){
                var _this = this;

                if(!_this.login)return this.$mslogin.open();
                if(!_this.ua.areaId)return this.$bind();

                this.$axios.post(this.$global.ajax_url_map.apply_gift,{
                    id : 1,
                })
                .then(res => {
                    if(res.data.code == 0){
                        _this.$toast('领取成功~');
                        _this.gift_apply = 0;
                    }
                    else{
                        _this.$toast(res.data.message);
                    }
                })
            },
            get_task_info(){
                var _this = this;
                var orderList = ['y01','y02','y03','y04','y05'];
                _this.$axios.get(_this.$global.ajax_url_map.task_detail,{
                    params: {
                        type : 1,
                    }
                })
                .then(res => {
                    if(res.data.code == 0){
                        //TODO
                    _this.ready = true;


                    for(var i = 0;i < orderList.length;i++){
                        var temp = res.data.data.filter(function(e){ return e.taskNo == orderList[i] })[0];
                        _this.reward_list[i] = {
                            giftId : temp.giftList[0].giftId,
                            giftName : temp.giftList[0].giftName,
                            sendNum : temp.giftList[0].sendNum,
                        };                        
                    }

                    // for(var i = 0;i < res.data.data.length;i++){
                    //     _this.reward_list[i] = {
                    //         giftId : res.data.data[i].giftList[0].giftId,
                    //         giftName : res.data.data[i].giftList[0].giftName,
                    //         sendNum : res.data.data[i].giftList[0].sendNum,
                    //     };
                    // }
                    }
                    else{
                        _this.$toast('任务信息模块:' + res.data.message);
                    }
                });          
            },
            get_friend_list (){
                var _this = this;

                if(!_this.login)return this.$mslogin.open();
                if(!_this.ua.areaId)return this.$bind();

                this.$axios.get(this.$global.ajax_url_map.friend_list,{
                    params : {
                        pageindex : 1,
                        pagesize : 10,
                    }               
                })
                .then(res => {
                    if(res.data.code == 0){
                        if(!res.data.data.list.length) return _this.$toast('您暂无回归好友');
                        _this.$friend_modal({
                            list : res.data.data.list,
                            allpages : Math.min(res.data.data.allPages,10),
                            code : _this.ua.inviteCode,           
                        });                        
                    }
                    else{
                        _this.$toast(res.data.message);
                    }
                });
            },
            login_task_info (){
                var _this = this;
            },                       
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/friend.vue